// extracted by mini-css-extract-plugin
export var aiStarIcon = "_sz-2";
export var container = "_sz-4";
export var dismissButton = "_sz-3";
export var hasPaddingBottom = "_sz-6";
export var last = "_sz-e";
export var scrollbarThumb = "_sz-c";
export var scrollbarTrack = "_sz-b";
export var selected = "_sz-9";
export var spin = "_sz-1";
export var spinning = "_sz-0";
export var suggestionItem = "_sz-d";
export var suggestionsPanel = "_sz-5";
export var tonePill = "_sz-8";
export var tonesContainer = "_sz-7";
export var unselected = "_sz-a";